export const WWWeaponsReleaseJSON = [
  {
    Name: 'Dauntless Evernight',
    Rarity: 4,
    ID: '21010044',
    Effect:
      'When Intro Skill is released, increases ATK by {0} and DEF by {1}, lasting for {2}s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: ['15%', '18.75%', '22.5%', '6.25%', '30%'],
    Array_2: [15, 15, 15, 15, 15],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 337,
    Stat_secondary: 'DEF',
    Stat_secondary_value: 61.5,
    Source: ''
  },
  {
    Name: 'Amity Accord',
    Rarity: 4,
    ID: '21040044',
    Effect:
      'When Intro Skill is released, increases Resonance Liberation DMG Bonus by {0}, lasting for {1}s.',
    Array_0: ['20%', '25%', '30%', '35%', '40%'],
    Array_1: ['15', '15', '15', '15', '15'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 337,
    Stat_secondary: 'DEF',
    Stat_secondary_value: 61.5,
    Source: ''
  },
  {
    Name: 'Gauntlets of Voyager',
    Rarity: 3,
    ID: '21040043',
    Effect:
      'When Resonance Skill is released, restores Resonance Energy by {0}. This effect can be triggered {2} time(s) every {1}.',
    Array_0: [8, 9, 10, 11, 12],
    Array_1: [20, 20, 20, 20, 20],
    Array_2: [1, 1, 1, 1, 1],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 325,
    Stat_secondary: 'DEF',
    Stat_secondary_value: 30.7,
    Source: ''
  },
  {
    Name: 'Originite: Type I',
    Rarity: 3,
    ID: '21010023',
    Effect:
      'When Resonance Skill is released, restores HP by {0}. This effect can be triggered {2} time(s) every {1}s.',
    Array_0: ['3%', '3.75%', '4.5%', '5.25%', '6%'],
    Array_1: [12, 12, 12, 12, 12],
    Array_2: [1, 1, 1, 1, 1],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 300,
    Stat_secondary: 'DEF',
    Stat_secondary_value: 38.4,
    Source: ''
  },
  {
    Name: 'Guardian Gauntlets',
    Rarity: 3,
    ID: '21040053',
    Effect: 'Increases Resonance Liberation DMG Bonus by {0}.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 300,
    Stat_secondary: 'DEF',
    Stat_secondary_value: 38.4,
    Source: ''
  },
  {
    Name: 'Lustrous Razor',
    Rarity: 5,
    ID: '21010015',
    Effect:
      'Increases Energy Regen by {0}. When Resonance Skill is released, increases Resonance Liberation DMG by {1}, stacking up to {2} times. This effect lasts for {3}s.',
    Array_0: ['12.8%', '16%', '19.2%', '22.4%', '25.6%'],
    Array_1: ['7%', '8.75%', '10.5%', '12.5%', '14%'],
    Array_2: [3, 3, 3, 3, 3],
    Array_3: [12, 12, 12, 12, 12],
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 587,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: 'Permanent Convene'
  },
  {
    Name: 'Abyss Surges',
    Rarity: 5,
    ID: '21040015',
    Effect:
      'Increases Energy Regen by {0}. When hitting a target with Resonance Skill, increases Basic Attack DMG Bonus by {1}, lasting for {2}. When hitting a target with Basic Attacks, increases Resonance Skill DMG Bonus by {3}, lasting for {4}s.',
    Array_0: ['12.8%', '16%', '19.2%', '22.4%', '25.6%'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: [8, 8, 8, 8, 8],
    Array_3: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_4: [8, 8, 8, 8, 8],
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 587,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: 'Permanent Convene'
  },
  {
    Name: 'Cosmic Ripples',
    Rarity: 5,
    ID: '21050015',
    Effect:
      'Increases Energy Regen by {0}. When hitting a target with Basic Attacks, increases Basic Attack DMG Bonus by {1}, stacking up to {2} time(s). This effect lasts for {3}s and can be triggered 1 time(s) every 0.5s.',
    Array_0: ['12.8%', '16%', '19.2%', '22.4%', '25.6%'],
    Array_1: ['3.2%', '4%', '4.8%', '5.6%', '6.4%'],
    Array_2: [5, 5, 5, 5, 5],
    Array_3: [8, 8, 8, 8, 8],
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 500,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 54.0,
    Source: 'Permanent Convene'
  },
  {
    Name: 'Commando of Conviction',
    Rarity: 4,
    ID: '21020044',
    Effect:
      'When Intro Skill is released, increases ATK by {0}, lasting for {1}.',
    Array_0: ['15%', '18.75%', '22.5%', '26.25%', '30%'],
    Array_1: [15, 15, 15, 15, 15],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 412,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Undying Flame',
    Rarity: 4,
    ID: '21030044',
    Effect:
      'When Intro Skill is released, increases Resonance Skill DMG Bonus by {0} for {1}s.',
    Array_0: ['20%', '25%', '30%', '35%', '40%'],
    Array_1: [15, 15, 15, 15, 15],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 412,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Jinzhou Keeper',
    Rarity: 4,
    ID: '21050044',
    Effect:
      "When Intro Skill is released, increases the caster's ATK by {0} and HP by {1}, lasting for {2}s.",
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: [15, 15, 15, 15, 15],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 387,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: ''
  },
  {
    Name: 'Helios Cleaver',
    Rarity: 4,
    ID: '21010064',
    Effect:
      'Within {0}s after Resonance Skill is cast, increases ATK by {2} every 2s, stacking up to 4 time(s). This effect can be triggered 1 time(s) every 12s. When the number of stacks reaches 4, all stacks will be reset within 6s.',
    Array_0: [12, 12, 12, 12, 12],
    Array_1: [2, 2, 2, 2, 2],
    Array_2: ['3%', '3.75%', '4.5%', '5.25%', '6%'],
    Array_3: [4, 4, 4, 4, 4],
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 412,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Lunar Cutter',
    Rarity: 4,
    ID: '21020064',
    Effect:
      'Equipped Resonator gains 6 stack(s) of Oath upon entering the battlefield. Each stack increases ATK by {0}, up to 6 stacks. This effect can be triggered 1 time(s) every 12s. Oath reduces by 1 stack(s) every 2s. Equipped Resonator gains an additional <b>6</b> stack(s) of Oath upon defeating an enemy.',
    Array_0: ['2%', '2.5%', '3%', '3.5%', '4%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 412,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Novaburst',
    Rarity: 4,
    ID: '21030064',
    Effect:
      'When the Resonator dashes or dodges, increases ATK by {0}, stacking up to <b>3</b> time(s). This effect lasts for <b>8</b>s.',
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 412,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Hollow Mirage',
    Rarity: 4,
    ID: '21040064',
    Effect:
      'When Resonance Liberation is released, grants 3 stack(s) of Iron Armor. Each stack increases ATK and DEF by {0}, stacking up to 3 time(s). When the Resonator takes damage, reduces the number of stacks by 1.',
    Array_0: ['3%', '3.5%', '4%', '4.5%', '5%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 412,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Comet Flare',
    Rarity: 4,
    ID: '21050064',
    Effect:
      'When hitting a target with Basic Attacks or Heavy Attacks, increases Healing Bonus by {0}, stacking up to 3 time(s). This effect lasts for 8s and can be triggered 1 time(s) every 0.6s.',
    Array_0: ['3%', '3.5%', '4%', '4.5%', '5%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 412,
    Stat_secondary: 'HP',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Broadblade of Night',
    Rarity: 3,
    ID: '21010013',
    Effect:
      'When Intro Skill is released, increases ATK by {0}, lasting for 10s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Sword of Night',
    Rarity: 3,
    ID: '21020013',
    Effect:
      'When Intro Skill is released, increases ATK by {0}, lasting for 10s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Pistols of Night',
    Rarity: 3,
    ID: '21030013',
    Effect:
      'When Intro Skill is released, increases ATK by {0}, lasting for 10s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Gauntlets of Night',
    Rarity: 3,
    ID: '21040013',
    Effect:
      'When Intro Skill is released, increases ATK by {0}, lasting for 10s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Rectifier of Night',
    Rarity: 3,
    ID: '21050013',
    Effect:
      'When Intro Skill is released, increases ATK by {0}, lasting for 10s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Pistols of Voyager',
    Rarity: 3,
    ID: '21030043',
    Effect:
      'When Resonance Skill is released, restores Resonance Energy by {0}. This effect can be triggered 1 time(s) every 20s.',
    Array_0: [8, 9, 10, 11, 12],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 300,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Originite: Type II',
    Rarity: 3,
    ID: '21020023',
    Effect:
      'When Resonance Liberation is released, restores HP by {0}. This effect can be triggered 1 time(s) every 20s.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%,', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Originite: Type III',
    Rarity: 3,
    ID: '21030023',
    Effect:
      'When Counter Attack is released, restores HP by {0}. This effect can be triggered 1 time(s) every 6s.',
    Array_0: ['1.6%', '2%', '2.4%', '2.8%', '3.2%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Stringmaster',
    Rarity: 5,
    ID: '21050016',
    Effect:
      'Increases the DMG Bonus by {0}. When dealing Resonance Skill DMG, increases ATK by {1}, stacking up to 2. This effect lasts for 5s. When the equipped Resonator is not on the field, increases their ATK by an additional {2}.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['12%', '15%', '18%', '21%', '24%'],
    Array_2: ['12%', '15%', '18%', '21%', '24%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 500,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 36,
    Source: 'Limited'
  },
  {
    Name: 'Guardian Rectifier',
    Rarity: 3,
    ID: '21050053',
    Effect: 'Increases Basic Attack and Heavy Attack DMG Bonus by {0}.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Guardian Pistols',
    Rarity: 3,
    ID: '21030053',
    Effect: 'Increases Resonance Skill DMG Bonus by {0}.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Guardian Broadblade',
    Rarity: 3,
    ID: '21010053',
    Effect: 'The damage of Basic Attack and Heavy Attack is increased by {0}.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 325,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 24.3,
    Source: ''
  },
  {
    Name: 'Pistols#26',
    Rarity: 4,
    ID: '21030034',
    Effect:
      'When the Resonator takes no damage, increases ATK by {0} every 5s, stacking up to 2 time(s). This effect lasts for 8s. When the Resonator takes damage, reduces the number of stacks by 1 and restores their HP by {1}.',
    Array_0: ['6%', '7.5%', '9%', '10.5%', '12%'],
    Array_1: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 387,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: 'Synthesis'
  },
  {
    Name: 'Sword#18',
    Rarity: 4,
    ID: '21020034',
    Effect:
      "When Equipped Resonator's HP drops below {0}, increases Heavy Attack DMG by {1} and restores HP by {2} upon dealing Heavy Attack DMG. This effect can be triggered 1 time(s) every 8s.",
    Array_0: ['40%', '50%', '60%', '70%', '80%'],
    Array_1: ['18%', '22.5%', '27%', '31.5%', '36%'],
    Array_2: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 387,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: 'Synthesis'
  },
  {
    Name: 'Training Broadblade',
    Rarity: 1,
    ID: '21010011',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 250,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 11.4,
    Source: ''
  },
  {
    Name: 'Training Sword',
    Rarity: 1,
    ID: '21020011',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 250,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 11.4,
    Source: ''
  },
  {
    Name: 'Training Pistols',
    Rarity: 1,
    ID: '21030011',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 250,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 11.4,
    Source: ''
  },
  {
    Name: 'Training Gauntlets',
    Rarity: 1,
    ID: '21040011',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 250,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 11.4,
    Source: ''
  },
  {
    Name: 'Training Rectifier',
    Rarity: 1,
    ID: '21050011',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 250,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 11.4,
    Source: ''
  },
  {
    Name: 'Tyro Sword',
    Rarity: 2,
    ID: '21020012',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 275,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 14.8,
    Source: ''
  },
  {
    Name: 'Tyro Broadblade',
    Rarity: 2,
    ID: '21010012',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 275,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 14.8,
    Source: ''
  },
  {
    Name: 'Tyro Pistols',
    Rarity: 2,
    ID: '21030012',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 275,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 14.8,
    Source: ''
  },
  {
    Name: 'Tyro Gauntlets',
    Rarity: 2,
    ID: '21040012',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 275,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 14.8,
    Source: ''
  },
  {
    Name: 'Tyro Rectifier',
    Rarity: 2,
    ID: '21050012',
    Effect: 'Increases ATK by {0}.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 275,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 14.8,
    Source: ''
  },
  {
    Name: 'Thunderbolt',
    Rarity: 4,
    ID: '21030074',
    Effect:
      'When hitting a target with Basic Attacks or Heavy Attacks, increases Resonance Skill DMG Bonus by {0}, stacking up to 3 time(s). This effect lasts for 10s and can be triggered 1 time(s) every 1s.',
    Array_0: ['7%', '11%', '15%', '19%', '23%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 387,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: 'Pioneer Podcast'
  },
  {
    Name: 'Lumingloss',
    Rarity: 4,
    ID: '21020074',
    Effect:
      'When Resonance Skill is released, increases Basic Attack DMG and Heavy Attack DMG by {0}, stacking up to 1 time(s). This effect lasts for 10s and can be triggered 1 time(s) every 1s.',
    Array_0: ['20%', '31%', '42%', '53%', '64%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 387,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 36.4,
    Source: 'Pioneer Podcast'
  },
  {
    Name: 'Originite: Type V',
    Rarity: 3,
    ID: '21050023',
    Effect:
      'When Intro Skill is released, restores HP by {0}%. This effect can be triggered 1 time(s) every 20s.',
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 300,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Guardian Sword',
    Rarity: 3,
    ID: '21020053',
    Effect: 'Increases Resonance Skill DMG by {0}.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 300,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.3,
    Source: ''
  },
  {
    Name: 'Overture',
    Rarity: 4,
    ID: '21020024',
    Effect:
      'When Resonance Skill is released, restores Concerto Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 10, 12, 14, 16],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 337,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 51.8,
    Source: ''
  },
  {
    Name: 'Discord',
    Rarity: 4,
    ID: '21010024',
    Effect:
      'When Resonance Skill is released, restores Concerto Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 10, 12, 14, 16],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 337,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 51.8,
    Source: ''
  },
  {
    Name: 'Cadenza',
    Rarity: 4,
    ID: '21030024',
    Effect:
      'When Resonance Skill is released, restores Concerto Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 10, 12, 14, 16],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 337,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 51.8,
    Source: ''
  },
  {
    Name: 'Marcato',
    Rarity: 4,
    ID: '21040024',
    Effect:
      'When Resonance Skill is released, restores Concerto Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 10, 12, 14, 16],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 337,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 51.8,
    Source: ''
  },
  {
    Name: 'Variation',
    Rarity: 4,
    ID: '21050024',
    Effect:
      'When Resonance Skill is released, restores Concerto Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 10, 12, 14, 16],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 337,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 51.8,
    Source: ''
  },
  {
    Name: 'Broadblade of Voyager',
    Rarity: 3,
    ID: '21010043',
    Effect:
      'When Resonance Skill is released, restores Resonance Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 9, 10, 11, 12],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 300,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 32.3,
    Source: ''
  },
  {
    Name: 'Sword of Voyager',
    Rarity: 3,
    ID: '21020043',
    Effect:
      'When Resonance Skill is released, restores Resonance Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 9, 10, 11, 12],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 300,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 32.3,
    Source: ''
  },
  {
    Name: 'Rectifier of Voyager',
    Rarity: 3,
    ID: '21050043',
    Effect:
      'When Resonance Skill is released, restores Resonance Energy by {0}. This effect can be triggered 1 time every 20s.',
    Array_0: [8, 9, 10, 11, 12],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 300,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 32.3,
    Source: ''
  },
  {
    Name: 'Rectifier#25',
    Rarity: 4,
    ID: '21050034',
    Effect:
      "When Resonance Skill is released, if the Resonator's HP is below 60%, restores their HP by {0}. This effect can be triggered 1 time(s) every 8s; if the Resonator's HP is above 60%, increases ATK by {1}, lasting for 10s.",
    Array_0: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_1: ['12%', '15%', '18%', '21%', '24%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 337,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 51.8,
    Source: 'Synthesis'
  },
  {
    Name: 'Gauntlets#21D',
    Rarity: 4,
    ID: '21040034',
    Effect:
      "When the Resonator dashes or dodges, increases ATK by {0}. Increases Counter Attack DMG by {1}, lasting for 8s. When Counter Attack is performed, restores the Resonator's HP by {2}. This effect can be triggered 1 time(s) every 6s.",
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: ['50%', '62.5%', '75%', '87.5%', '100%'],
    Array_2: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 387,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 38.8,
    Source: 'Synthesis'
  },
  {
    Name: 'Broadblade#41',
    Rarity: 4,
    ID: '21010034',
    Effect:
      "When the Resonator's HP is above 80%, increases ATK by {0}. When the Resonator's HP is below {1}, restores their HP by {2}, for dealing Basic Attack DMG or Heavy Attack DMG. This effect can be triggered 1 time(s) every 8s.",
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['40%', '50%', '60%', '70%', '80%'],
    Array_2: ['5%', '6.25%', '7.5%', '8.75%', '10%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 412,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 32.3,
    Source: 'Synthesis'
  },
  {
    Name: 'Verdant Summit',
    Rarity: 5,
    ID: '21010016',
    Effect:
      'Increases the DMG Bonus of all Resonance Attributes by {0}. Every time Intro Skill or Resonance Liberation is cast, increases Heavy Attack DMG Bonus by {1}, stacking up to 2 time(s). This effect lasts for 14s.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['24%', '30%', '36%', '42%', '48%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 587,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 48.6,
    Source: 'Limited'
  },
  {
    Name: 'Originite: Type IV',
    Rarity: 3,
    ID: '21040023',
    Effect:
      'When hitting a target with Basic Attacks, restores HP by {0}. This effect can be triggered 1 time(s) every 3s.',
    Array_0: ['0.5%', '0.65%', '0.8%', '0.95%', '1.1%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 300,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 40.5,
    Source: ''
  },
  {
    Name: 'Augment',
    Rarity: 4,
    ID: '21050074',
    Effect:
      "When Resonance Liberation is released, increases the caster's ATK by {0}, lasting for 15s.",
    Array_0: ['15%', '23.25%', '31.5%', '39.75%', '48%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 412,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 20.2,
    Source: 'Pioneer Podcast'
  },
  {
    Name: 'Emerald of Genesis',
    Rarity: 5,
    ID: '21020015',
    Effect:
      'Increases Energy Regen by {0}. When Resonance Skill is released, increases ATK by {1}, stacking up to 2 time(s). This effect lasts for 10s.',
    Array_0: ['12.8%', '16%', '19.2%', '22.4%', '25.6%'],
    Array_1: ['6%', '7.5%', '9%', '10.5%', '12%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 587,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 24.3,
    Source: 'Permanent Convene'
  },
  {
    Name: 'Static Mist',
    Rarity: 5,
    ID: '21030015',
    Effect:
      "Increases Energy Regen by {0}. When Outro Skill is released, increases the switched-in Resonator's ATK by {1}, stacking up to 1 time(s). This effect lasts for 14s.",
    Array_0: ['12.8%', '16%', '19.2%', '22.4%', '25.6%'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 587,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 24.3,
    Source: 'Permanent Convene'
  },
  {
    Name: 'Stonard',
    Rarity: 4,
    ID: '21040074',
    Effect:
      "When Resonance Skill is released, increases the caster's Resonance Liberation DMG Bonus by {0}, lasting for 15s.",
    Array_0: ['18%', '27%', '36%', '45%', '54%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 412,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 20.2,
    Source: 'Pioneer Podcast'
  },
  {
    Name: 'Autumntrace',
    Rarity: 4,
    ID: '21010074',
    Effect:
      'Increases ATK by {0} upon dealing Basic Attack DMG or Heavy Attack DMG, stacking up to 5 time(s). This effect lasts for 7s and can be triggered 1 time(s) every 1s.',
    Array_0: ['4%', '6%', '8.4%', '10.6%', '12.8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 412,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 20.2,
    Source: 'Pioneer Podcast'
  },
  {
    Name: 'Ages of Harvest',
    Rarity: 5,
    ID: '21010026',
    Effect:
      'Grants {0} Attribute DMG Bonus. Casting Intro Skill gives the equipper Ageless Marking, which grants {1} Resonance Skill DMG Bonus for 12s. Casting Resonance Skill gives the equipper Ethereal Endowment, which grants {1} Resonance Skill DMG Bonus for 12s.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['24%', '30%', '36%', '42%', '48%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 587,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 24.3,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Beguiling Melody',
    Rarity: 3,
    ID: '21010063',
    Effect:
      'When Intro Skill is cast, restores {0} Concerto Energy. When Outro Skill is cast, restores {0} Resonance Energy.',
    Array_0: ['4', '5', '6', '7', '8'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 300,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 30.4,
    Source: 'Gacha'
  },
  {
    Name: 'Blazing Brilliance',
    Rarity: 5,
    ID: '21020016',
    Effect:
      'ATK increased by {0}. The equipper gains 1 stack of Searing Feather upon dealing damage, which can be triggered once every 0.5s, and gains 5 stacks of the same effect upon casting Resonance Skill. Each stack of Searing Feather gives {1} additional Resonance Skill DMG Bonus for up to 14 stacks. All stacks will be removed within 12s after reaching the max stack.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['4%', '5%', '6%', '7%', '8%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 587,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 48.6,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Rime-Draped Sprouts',
    Rarity: 5,
    ID: '21050026',
    Effect:
      'Increases ATK by {0}. Using Resonance Skill gives the equipped Resonator {0} Basic Attack DMG Bonus for 6s, stacking up to 3 times. When casting Outro Skill with 3 stacks, consume all stacks to give {1} DMG Bonus to the off-field Basic Attacks performed by the equipped Resonator, lasting for 27s.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['52%', '65%', '78%', '91%', '104%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 500,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 72,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: "Verity's Handle",
    Rarity: 5,
    ID: '21040016',
    Effect:
      'Gain {0} Attribute DMG Bonus. When using Resonance Liberation, the wielder gains {1} Resonance Liberation DMG Bonus for 8s. This effect can be extended by 5 seconds each time Resonance Skills are cast, up to 3 times.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['48%', '60%', '72%', '84%', '94%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 587,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 24.3,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Stellar Symphony',
    Rarity: 5,
    ID: '21050036',
    Effect:
      "Increase HP by {0}. Restore {1} Concerto Energy when casting Resonance Liberation. This effect can be triggered 1 time(s) every 20s. When casting Resonance Skill that heals, increase nearby party members' ATK by {2} for 30s. Effects of the same name cannot be stacked.",
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['8', '10', '12', '14', '16'],
    Array_2: ['14%', '17.5%', '21%', '24.5%', '28%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 412,
    Stat_secondary: 'Energy Regen',
    Stat_secondary_value: 77,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Endless Collapse',
    Rarity: 4,
    ID: '21020084',
    Effect:
      'Casting the Resonance Skill grants {0} Resonance Energy and increases ATK by {1}, lasting for 16s. This effect can be triggered once every 20s.',
    Array_0: ['6', '7', '8', '9', '10'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Celestial Spiral',
    Rarity: 4,
    ID: '21040084',
    Effect:
      'Casting the Resonance Skill grants {0} Resonance Energy and increases ATK by {1}, lasting for 16s. This effect can be triggered once every 20s.',
    Array_0: ['6', '7', '8', '9', '10'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Relativistic Jet',
    Rarity: 4,
    ID: '21030084',
    Effect:
      'Casting the Resonance Skill grants {0} Resonance Energy and increases ATK by {1}, lasting for 16s. This effect can be triggered once every 20s.',
    Array_0: ['6', '7', '8', '9', '10'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Fusion Accretion',
    Rarity: 4,
    ID: '21050084',
    Effect:
      'Casting the Resonance Skill grants {0} Resonance Energy and increases ATK by {1}, lasting for 16s. This effect can be triggered once every 20s.',
    Array_0: ['6', '7', '8', '9', '10'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Waning Redshift',
    Rarity: 4,
    ID: '21010084',
    Effect:
      'Casting the Resonance Skill grants {0} Resonance Energy and increases ATK by {1}, lasting for 16s. This effect can be triggered once every 20s.',
    Array_0: ['6', '7', '8', '9', '10'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Red Spring',
    Rarity: 5,
    ID: '21020026',
    Effect:
      "Increase ATK by {0}. When dealing Basic Attack DMG, the wielder gains {1} Basic Attack DMG Bonus for 14s. This effect can be triggered once per second, stacking up to 3 times. When the wielder's Concerto Energy is consumed, gain {2} Basic DMG Bonus for 10s. This effect can be triggered once per second and ends when the wielder is switched off the field.",
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['10%', '12.5%', '15%', '17.5%', '20%'],
    Array_2: ['40%', '50%', '60%', '70%', '80%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 587,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 24.3,
    Source: 'Gacha',
    isNew: false
  },
  {
    Name: 'Somnoire Anchor',
    Rarity: 4,
    ID: '21020017',
    Effect:
      "Gain 1 stack of Hiss when dealing damage to the target, with 1 stack generated every 1s. Hiss: each stack increases the wielder's ATK by {0} for 3s, stacking up to 10 times. Switching off the wielder clears all stacks. Gaining 10 stacks increases the wielder's Crit. Rate by {1}.",
    Array_0: ['2%', '2.5%', '3%', '3.5%', '4%'],
    Array_1: ['6%', '7.5%', '9%', '10.5%', '12%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Event',
    isNew: false
  },
  {
    Name: 'Fables of Wisdom',
    Rarity: 4,
    ID: '21020094',
    Effect:
      "Dealing DMG to enemies with Negative Statuses increases the wielder's ATK by {0} for 10s. This effect can be triggered 1 time per second, stackable up to 4 times.",
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Crafting',
    isNew: false
  },
  {
    Name: 'Meditations on Mercy',
    Rarity: 4,
    ID: '21010094',
    Effect:
      "Dealing DMG to enemies with Negative Statuses increases the wielder's ATK by {0} for 10s. This effect can be triggered 1 time per second, stackable up to 4 times.",
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Broadblade',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Crafting',
    isNew: false
  },
  {
    Name: 'Romance in Farewell',
    Rarity: 4,
    ID: '21030094',
    Effect:
      "Dealing DMG to enemies with Negative Statuses increases the wielder's ATK by {0} for 10s. This effect can be triggered 1 time per second, stackable up to 4 times.",
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Crafting',
    isNew: false
  },
  {
    Name: 'Legend of Drunken Hero',
    Rarity: 4,
    ID: '21040094',
    Effect:
      "Dealing DMG to enemies with Negative Statuses increases the wielder's ATK by {0} for 10s. This effect can be triggered 1 time per second, stackable up to 4 times.",
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Crafting',
    isNew: false
  },
  {
    Name: 'Waltz in Masquerade',
    Rarity: 4,
    ID: '21050094',
    Effect:
      "Dealing DMG to enemies with Negative Statuses increases the wielder's ATK by {0} for 10s. This effect can be triggered 1 time per second, stackable up to 4 times.",
    Array_0: ['4%', '5%', '6%', '7%', '8%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Crafting',
    isNew: false
  },
  {
    Name: 'The Last Dance',
    Rarity: 5,
    ID: '21030016',
    Effect:
      'Increases ATK by {0}. Every time Intro Skill or Resonance Liberation is cast, Resonance Skill DMG Bonus increases by {1} for 5s.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['48%', '60%', '72%', '84%', '96%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Pistols',
    Stat_primary: 500,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 72,
    Source: 'Rate-up',
    isNew: false
  },
  {
    Name: 'Tragicomedy',
    Rarity: 5,
    ID: '21040026',
    Effect:
      'Increases ATK by {0}. Every time Basic Attack or Intro Skill is cast, Heavy Attack DMG Bonus increases by {1} for 3s.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['48%', '60%', '72%', '84%', '96%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 587,
    Stat_secondary: 'CRIT Rate',
    Stat_secondary_value: 24.3,
    Source: 'Rate-up',
    isNew: false
  },
  {
    Name: 'Call of the Abyss',
    Rarity: 4,
    ID: '21050017',
    Effect:
      "Casting Resonance Liberation increases the Resonator's Healing Bonus by {0} for 15s.",
    Array_0: ['16%', '20%', '24%', '28%', '32%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 338,
    Stat_secondary: 'Energy Regen',
    Stat_secondary_value: 51.8,
    Source: 'Event',
    isNew: false
  },
  {
    Name: 'Luminous Hymn',
    Rarity: 5,
    ID: '21050046',
    Effect:
      'Increase ATK by {0}. Dealing DMG to targets with Spectro Frazzle grants the wielder {1} Basic Attack DMG Bonus and {1} Heavy Attack DMG Bonus, stacking up to 3 times for 6s. Casting Outro Skill Amplifies the Spectro Frazzle DMG on targets around the active Resonator by {2} for 30s. Effects of the same name cannot be stacked.',
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['14%', '17.5%', '21%', '24.5%', '28%'],
    Array_2: ['30%', '37.5%', '45%', '52.5%', '60%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 500,
    Stat_secondary: 'Crit. Rate',
    Stat_secondary_value: 36,
    Source: 'Rate-up',
    isNew: false
  },
  {
    Name: "Ocean's Gift",
    Rarity: 4,
    ID: '21050027',
    Effect:
      "Dealing DMG to enemies with Spectro Frazzle increases the wielder's Spectro DMG by {0}, gaining 1 stack per second for 6s, stacking up to 4 times.",
    Array_0: ['6%', '7%', '8%', '9%', '10%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 462,
    Stat_secondary: 'ATK',
    Stat_secondary_value: 18.2,
    Source: 'Event',
    isNew: false
  },
  {
    Name: 'Unflickering Valor',
    Rarity: 5,
    ID: '21020036',
    Effect:
      'Increase Crit. Rate by {0}. Casting Resonance Liberation gives {1} Basic Attack DMG Bonus for 10s. Dealing Basic Attack DMG gives {1} Basic Attack DMG Bonus for 4s.',
    Array_0: ['8%', '10%', '12%', '14%', '16%'],
    Array_1: ['24%', '30%', '36%', '42%', '48%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 415,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 77,
    Source: 'Rate-up',
    isNew: false
  },
  {
    Name: "Bloodpact's Pledge",
    Rarity: 5,
    ID: '21020046',
    Effect:
      'Providing Healing increases Resonance Skill DMG by {0} for 6s. When Rover: Aero casts Resonance Skill Unbound Flow, Aero DMG dealt by nearby Resonators on the field is Amplified by {0} for 30s.',
    Array_0: ['10%', '14%', '18%', '22%', '26%'],
    Array_1: '',
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Sword',
    Stat_primary: 588,
    Stat_secondary: 'Energy Reg.',
    Stat_secondary_value: 38.9,
    Source: 'Rate-up',
    isNew: false
  },
  {
    Name: 'Whispers of Sirens',
    Rarity: 5,
    ID: '21050056',
    Effect:
      "Increases ATK by {0}. Casting Echo Skill within 10s after casting Intro Skill or Basic Attacks grants 1 stacks of Gentle Dream. Echoes with the same name can only trigger this effect once, stacking up to 2 times, lasting for 10s. When reaching 2 stacks, casting Echo Skill no longer resets the duration of this effect. This effect activates up to once per 10s. Switching to another Resonator ends this effect early.<br />With 1 stacks: Grants {1} Basic Attack DMG Bonus.<br />With 2 stacks: Ignores {0} of the target's Havoc RES.",
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['40%', '50%', '60%', '70%', '80%'],
    Array_2: '',
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Rectifier',
    Stat_primary: 500,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 72,
    Source: 'Rate-up',
    isNew: false
  },
  {
    Name: 'Blazing Justice',
    Rarity: 5,
    ID: '21040036',
    Effect:
      "Increases ATK by {0}. Casting Basic Attack grants the following effects: Dealing damage ignores {1} of the target's DEF and Amplifies Spectro Frazzle DMG dealt by {2} for 6s. Retriggering the effect resets its duration.",
    Array_0: ['12%', '15%', '18%', '21%', '24%'],
    Array_1: ['8%', '10%', '12%', '14%', '16%'],
    Array_2: ['50%', '62.5%', '75%', '87.5%', '100%'],
    Array_3: '',
    Array_4: '',
    Array_5: '',
    Array_6: '',
    Array_7: '',
    Weapon_Type: 'Gauntlets',
    Stat_primary: 587,
    Stat_secondary: 'CRIT DMG',
    Stat_secondary_value: 48.6,
    Source: 'Rate-up',
    isNew: true
  }
];
